/**
 * R5AvatarCard
 * -----------------------------------------------------------
 * Brass-circle avatar + name + role. Used in the Account page
 * aside slot of <R5FormPair>.
 *
 * Props:
 *   initials: string (1-2 letters)
 *   name:     display name
 *   role:     small uppercase role line
 *   image:    optional <img> node — replaces initials circle
 */
import React from 'react';

export function R5AvatarCard({ initials, name, role, image, className = '', ...rest }) {
  const cls = ['r5-avatar-card', className].filter(Boolean).join(' ');
  return (
    <div className={cls} {...rest}>
      <div className="r5-avatar-card__circle">
        {image || initials}
      </div>
      <div>
        {name && <div className="r5-avatar-card__name">{name}</div>}
        {role && <div className="r5-avatar-card__role">{role}</div>}
      </div>
    </div>
  );
}

export default R5AvatarCard;
